// @ts-strict-ignore
import { Button, Card, Flex, Text, mediaQuery } from "@hubble/web";
import styled from "styled-components";

export const AvailibilityRedirectCardContainer = styled(Card)`
  position: relative;
  min-height: 311px;
  grid-area: 6 / 1 / 8 / 6;
  display: flex;
  align-items: center;
  background-image: url("https://images.ctfassets.net/jg6lo9a2ukvr/1htdfNeUyoRppMGLp8trRC/d3828c412b254af5a4b65a8fc4013e8c/buy_module.png?fm=webp");
  background-position: right top;
  background-size: cover;
  background-repeat: no-repeat;
  @media ${mediaQuery.mobileXsDown} {
    background-image: url("https://images.ctfassets.net/jg6lo9a2ukvr/6H9rIbhVX1DSnSrYqFwfKd/b117a8b641213aa2888f98ce0a93a629/Priceconverter_globe_Mobile.png?fm=webp");
    background-position: center;
    background-size: cover;
    grid-area: 7 / 1 / 9 / -1;
  }
`;

export const AvailibilityRedirectCardContent = styled(Flex)`
  flex-direction: column;
  gap: 25px;
  justify-content: center;
  height: 100%;
  z-index: 3;
  position: relative;
`;

export const AvailibilityRedirectCardText = styled(Text.Heading)`
  max-width: 310px;
` as typeof Text.Heading;

export const AvailibilityRedirectCardButton = styled(Button.Primary)`
  width: max-content;
`;
